import clsx from 'clsx';
import { FC } from 'react';

import Button from '~components/generic/elements/Button';

export interface IModuleSliderArrowProps {
  className?: string;
  onClick?: () => void;
  direction: 'left' | 'right';
}

export const ModuleSliderArrow: FC<IModuleSliderArrowProps> = ({ className, onClick, direction }) => (
  <Button
    className={clsx({
      [className]: true,
      'c-button': true,
      'c-button--dark-transparent': true,
      'u-size-lg': true,
      'u-absolute': true,
      [`u-absolute--${direction}`]: true,
      [`u-margin-${direction}-sm`]: true,
      'u-padding-horizontal-none': true,
      'u-center-block__content--vertical': true,
    })}
    iconName={`caret-${direction}`}
    onClick={onClick}
  />
);

export default ModuleSliderArrow;
